"use client"

const MenuItemSkeleton = () => {
    return (
        <div className="w-full flex flex-col bg-white/5 p-4 rounded-lg animate-pulse">
            <div className="flex-grow w-full">
                {/* Image Skeleton */}
                <div className="w-full aspect-square rounded overflow-hidden bg-gray-700"></div>

                {/* Text Content Skeletons */}
                <div className="flex flex-col items-center gap-2 mt-4 w-full">
                    <div className="h-7 w-3/4 bg-gray-700 rounded"></div>
                    <div className="h-4 w-full bg-gray-700 rounded mt-2"></div>
                    <div className="h-4 w-5/6 bg-gray-700 rounded"></div>
                    <div className="h-4 w-4/5 bg-gray-700 rounded"></div>
                    <div className="h-6 w-16 bg-gray-700 rounded mt-2"></div>
                </div>
            </div>

            {/* Button Skeleton */}
            <div className="w-full h-10 bg-gray-700 rounded mt-4"></div>
        </div>
    )
}

export default MenuItemSkeleton
